<template>
  <aside id="sidebar" class="sidebar">
    <ul class="sidebar-nav" id="sidebar-nav">
      <li class="nav-item">
        <router-link
          to="/"
          class="nav-link collapsed"
          :class="{ active: isActive('/') }"
        >
          <i class="bi bi-grid"></i>
          <span>Dashboard</span>
        </router-link>
      </li>

      <li class="nav-heading">Main</li>

      <li class="nav-item">
        <router-link
          to="/instances"
          class="nav-link collapsed"
          :class="{ active: isActive('/instances') }"
        >
          <i class="bi bi-server"></i>
          <span>List Instances</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/broadcast"
          class="nav-link collapsed"
          :class="{ active: isActive('/broadcast') }"
        >
          <i class="bi bi-broadcast"></i>
          <span>Broadcast Queue</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/chat"
          class="nav-link collapsed"
          :class="{ active: isActive('/chat') }"
        >
          <i class="bi bi-chat"></i>
          <span>Message Room</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/contact"
          class="nav-link collapsed"
          :class="{ active: isActive('/contact') }"
        >
          <i class="bi bi-person-lines-fill"></i>
          <span>Contact List</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/checker"
          class="nav-link collapsed"
          :class="{ active: isActive('/checker') }"
        >
          <i class="bi bi-check-circle"></i>
          <span>Number Checker</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/worker-config"
          class="nav-link collapsed"
          :class="{ active: isActive('/worker-config') }"
        >
          <i class="bi bi-cpu"></i>
          <span>Worker Config</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/timeline"
          class="nav-link collapsed"
          :class="{ active: isActive('/timeline') }"
        >
          <i class="bi bi-calendar-event"></i>
          <span>Instance Timeline</span>
        </router-link>
      </li>

      <li class="nav-item">
        <a
          class="nav-link collapsed"
          data-bs-toggle="collapse"
          data-bs-target="#warming-nav"
          :class="{ active: isWarmingActive() }"
        >
          <i class="bi bi-fire"></i>
          <span>Warming</span>
          <i class="bi bi-chevron-down ms-auto"></i>
        </a>
        <ul id="warming-nav" class="nav-content collapse" data-bs-parent="#sidebar-nav">
          <li>
            <router-link to="/warming/rooms" :class="{ active: isActive('/warming/rooms') }">
              <i class="bi bi-circle"></i><span>Rooms</span>
            </router-link>
          </li>
          <li>
            <router-link to="/warming/logs" :class="{ active: isActive('/warming/logs') }">
              <i class="bi bi-circle"></i><span>Logs</span>
            </router-link>
          </li>
          <li>
            <a
              class="collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#settings-nav"
              :class="{ active: isSettingsActive() }"
            >
              <i class="bi bi-gear"></i>
              <span>Settings</span>
              <i class="bi bi-chevron-down ms-auto"></i>
            </a>
            <ul id="settings-nav" class="nav-content collapse">
              <li>
                <router-link to="/warming/scripts" :class="{ active: isActive('/warming/scripts') }" class="nested-item">
                  <i class="bi bi-dash"></i><span>Scripts</span>
                </router-link>
              </li>
              <li>
                <router-link to="/warming/templates" :class="{ active: isActive('/warming/templates') }" class="nested-item">
                  <i class="bi bi-dash"></i><span>Templates</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <li class="nav-heading">Settings</li>

      <li class="nav-item" v-if="isAdmin">
        <router-link
          to="/settings/identity"
          class="nav-link collapsed"
          :class="{ active: isActive('/settings/identity') }"
        >
          <i class="bi bi-shield-check"></i>
          <span>App Branding</span>
        </router-link>
      </li>

      <li class="nav-heading">Account</li>

      <li class="nav-item">
        <router-link
          to="/profile"
          class="nav-link collapsed"
          :class="{ active: isActive('/profile') }"
        >
          <i class="bi bi-person-circle"></i>
          <span>My Profile</span>
        </router-link>
      </li>

      <li class="nav-heading">Doc</li>

      <li class="nav-item">
        <router-link
          to="/doc"
          class="nav-link collapsed"
          :class="{ active: isActive('/doc') }"
        >
          <i class="bi bi-book"></i>
          <span>Api Documentation</span>
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from '@/composables/useAuth';

const route = useRoute();
const { user } = useAuth();

const isAdmin = computed(() => user.value?.role === 'admin');

function isActive(routePath) {
  return route.path === routePath;
}

function isWarmingActive() {
  return route.path.startsWith('/warming');
}

function isSettingsActive() {
  return route.path === '/warming/scripts' || route.path === '/warming/templates';
}
</script>
<style scoped>
/* Scoped styles removed in favor of global sidebar-theme.css for consistency */
.sidebar .nested-item {
  padding-left: 3rem !important;
}
</style>